module.exports = __webpack_public_path__ + "img/stema.8b8504e4.jpg";